import { BlogEditorExportFormat } from '../interfaces';
import { Octokit } from '@octokit/core';

/**
 * Sends a request to create a standalone Notion page with the provided content.
 * @param content - The content to be sent to the server.
 * @returns An object containing the success status, message, and optionally the pageId.
 */

export const createStandaloneNotionPage = async (
  content: BlogEditorExportFormat
): Promise<{
  success: boolean;
  message: string;
  pageId?: string;
}> => {
  try {
    const response = await fetch('http://localhost/blogEditorNotion', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(content),
    });

    const responseText = await response.text();

    // Check if the response is HTML
    if (responseText.trim().toLowerCase().startsWith('<!doctype') || responseText.trim().toLowerCase().startsWith('<html')) {
      console.error('Server returned HTML instead of JSON');

      if (response.status === 200) {
        return {
          success: true,
          message: 'Page likely created successfully (but server returned HTML)',
          pageId: 'unknown',
        };
      } else {
        return {
          success: false,
          message: 'Server returned HTML instead of JSON',
        };
      }
    }

    let responseData;
    try {
      responseData = JSON.parse(responseText);
    } catch (parseError) {
      return {
        success: false,
        message: `Failed to parse JSON: ${parseError instanceof Error ? parseError.message : String(parseError)}`,
      };
    }

    if (!responseData.success) {
      return {
        success: false,
        message: responseData.error || 'Unknown error creating Notion page',
      };
    }

    return {
      success: true,
      message: 'Page created successfully in Notion',
      pageId: responseData.pageId,
    };
  } catch (error) {
    console.error('Error creating standalone page:', error);
    return {
      success: false,
      message: error instanceof Error ? error.message : 'Failed to create page',
    };
  }
};

export const createGitGist = async (content: BlogEditorExportFormat) => {
  const token = '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'; // GitHub Personal Access Token
  const octokit = new Octokit({
    auth: token,
  });

  // 변환 함수: content를 export default {} 형태의 문자열로 변환
  const convertToExportDefault = (obj: any): string => {
    return (
      'export default ' +
      JSON.stringify(obj, null, 2)
        .replace(/"([^"]+)":/g, '$1:')
        .replace(/"([^"]*)"/g, "'$1'")
    );
  };

  const exportCode = convertToExportDefault(content);

  // pageUrl에서 /blog 이후의 텍스트 추출 → 파일명
  const urlParts = content.ogUrl?.split('/blog/');
  const fileName = urlParts && urlParts[1] ? `blog${urlParts[1]}.ts` : 'content.ts';

  try {
    const response = await octokit.request('POST /gists', {
      description: 'Example of a gist',
      public: true, // 공개 여부
      files: {
        [fileName]: {
          content: exportCode, // export default 형태로 저장
        },
      },
      headers: {
        'X-GitHub-Api-Version': '2022-11-28', // API 버전 명시 (optional)
      },
    });

    console.log(`Gist created with filename: ${fileName}, URL:`, response.data.html_url);

    return {
      success: true,
      message: 'Page created successfully in GIST',
    };
  } catch (error) {
    console.error('Error creating gist:', error);

    return {
      success: false,
      message: 'Failed',
    };
  }
};
